import { Account } from '@/types';

import {
  NotificationField,
  NotificationViewModal,
} from './NotificationViewModal';

interface EmailViewModalProps {
  /** Whether the modal is open */
  open: boolean;
  /** Callback when modal should close */
  onClose: () => void;
  /** The email account to view/edit */
  emailAccount: Account;
}

/**
 * EmailViewModal - Modal for viewing email configuration and editing severity threshold
 *
 * Features:
 * - Displays email address in plain text (not masked - not a secret)
 * - Copyable email address with green flash feedback
 * - Editable severity threshold dropdown
 * - Only severity can be edited (backend constraint - PUT only updates Settings)
 *
 * Note: Unlike webhook modals, email addresses are NOT masked because they are
 * not secrets. The copy functionality is provided for convenience.
 *
 * Used in:
 * - NotificationSettingsCards via EmailNotificationSection
 */
export function EmailViewModal({
  open,
  onClose,
  emailAccount,
}: EmailViewModalProps) {
  const fields: NotificationField[] = [
    {
      label: 'Email Address',
      value: emailAccount.value || '',
      type: 'copyable',
      testId: 'email-view-address',
    },
  ];

  return (
    <NotificationViewModal
      open={open}
      onClose={onClose}
      account={emailAccount}
      title="Email Configuration"
      username="email"
      fields={fields}
      successMessage="Email notification updated"
      errorMessage="Failed to update email notification"
      modalTestId="email-view-modal"
      saveButtonTestId="email-view-save-button"
      severitySelectTestId="email-view-severity-select"
      severitySelectName="email-severity"
    />
  );
}
